import { useState } from "react";
import mainStyle from "../../style/Main.module.css";
import MainLayout from "../../layouts/MainLayout";
import PageInputField from "../../components/ui/input/PagesInput/PagesInput";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import Button from "../../components/ui/buttons/Button";
import { MultiSelect } from "react-multi-select-component";
import Loader from "../../components/ui/Loader/Loader";
import Select from "react-select";
import {
  useSelectBoxCompany,
  useFetchSelectedUser,
} from "../../hooks/useCommonHooks";
import { useCreateChannel } from "../../hooks/useChannel";
import { getRegisterId } from "../../utils/authId";

const AddChannelPage = () => {
  const companyList = useSelectBoxCompany();
  const currentUserId = getRegisterId();
  const {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    setFormData,
    selectedCompanyId,
    setSelectedCompanyId,
  } = useCreateChannel();
  const users = useFetchSelectedUser(selectedCompanyId);

  const [selectKey, setSelectKey] = useState(0);

  const companyOptions = companyList.map((company) => ({
    label: company.company_name, // Replace 'name' with your actual company name property
    value: company.id, // Replace 'id' with your actual company ID property
  }));

  //   useEffect(() => {
  //     setFormData((prev) => ({
  //       ...prev,
  //       channel_people: [currentUserId, ...(prev.channel_people || [])],
  //     }));
  //   }, [currentUserId, setFormData]);

  const userOptions = users.map((user) => ({
    label: user.name,
    value: user.id,
  }));
  const handleCompanyChange = (option) => {
    const companyValue = option ? option.value : null;
    setSelectedCompanyId(companyValue); // Use 'value' instead of 'id'
    setFormData((prev) => ({
      ...prev,
      company: companyValue,
    }));
  };

  const handlePeopleChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      channel_people: [
        currentUserId,
        ...selected.map((option) => option.value),
      ],
    }));
  };

  const handleChannelNameChange = (e) => {
    let value = e.target.value;
    if (value && !value.startsWith("# ")) {
      value = value.replace(/^#\s?/, "");
      value = `# ${value}`;
    }
    handleInputChange({
      target: {
        name: e.target.name,
        value: value,
      },
    });
  };
  const handleFormSubmit = async () => {
    await handleSubmit();
    setSelectKey((prev) => prev + 1); // This will force the Select to re-render
  };
  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p className={mainStyle.mainHeading}>Add Channel:</p>
        </div>
        <div className={mainStyle.mainPageButtons}></div>
      </div>

      {/* {showFilter && (
      <div className={mainStyle.mainPageFilter}>
        <p>This is your filter section</p>
      </div>
    )} */}

      <div className={mainStyle.mainContentView} style={{ height: "84%" }}>
        <div className={mainStyle.mainContentViewsb}>
          <div className={mainStyle.mainContentCard}>
            <p className={mainStyle.aboutPageContent}>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Start a focused
              conversation by creating a channel. Channels help teams
              collaborate around specific topics or departments. Add a channel
              name, choose its type (public or private), and invite members to
              join. You can also add a channel icon and description to make it
              easily recognizable.
            </p>
            <div className={mainStyle.mainContentForm}>
              <div className={mainStyle.mainContentFormSplit}>
                <PageInputField
                  label="Channel Name"
                  name="channel_name"
                  placeholder="e.g , # Channel"
                  required
                  value={formData?.channel_name || ""}
                  onChange={handleChannelNameChange}
                  error={error.channel_name}
                />

                <PageInputField
                  label="Channel Topic"
                  name="channel_topic"
                  placeholder="e.g , Channel Topic"
                  required
                  value={formData?.channel_topic || ""}
                  onChange={handleInputChange}
                  error={error.channel_topic}
                />
              </div>
              {/* <p className={mainStyle.contentGuideOrd}>
                Note : You will receive your password in this email after
                completing your registration
              </p>
              <PageInputField
                label="Email"
                name="email"
                placeholder="e.g., john.doe@example.com"
                required
                value={formData.email || ""}
                onChange={handleInputChange}
                error={error.email}
              /> */}
              <p className={mainStyle.contentGuideOrd}>
                Note : Please select a company to proceed. Once a company is
                selected, the associated users will be automatically fetched and
                displayed.
              </p>
              <div className={mainStyle.mainContentFormSplit}>
                {/* <PageInputField
                  label="Phone"
                  name="phone"
                  placeholder="e.g., 876543210"
                  required
                  value={formData.phone || ""}
                  onChange={handleInputChange}
                  error={error.phone}
                /> */}
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Company<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <Select
                    key={selectKey} // Add this key to force re-render
                    className={mainStyle.selectBoxPage}
                    options={companyOptions}
                    onChange={handleCompanyChange}
                    value={companyOptions.find(
                      (option) => option.value === formData?.company
                    )}
                    isClearable={true}
                  />
                  {error.company && (
                    <span className={mainStyle.errorMsg}>{error.company}</span>
                  )}
                </div>
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Staff<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <MultiSelect
                    options={userOptions}
                    value={userOptions.filter((option) =>
                      formData?.channel_people?.includes(option.value)
                    )}
                    onChange={handlePeopleChange}
                    labelledBy="Select Companies"
                    className={mainStyle.mutiSelectDropDown}
                    overrideStrings={{
                      allItemsAreSelected: "All Staff selected",
                      selectSomeItems: "Select Staff",
                    }}
                  />
                  {error.channel_people && (
                    <span className={mainStyle.errorMsg}>
                      {error.channel_people}
                    </span>
                  )}
                </div>
                {/* <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Address<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <textarea
                    className={PageInputStyle.input}
                    name="address"
                    placeholder="e.g.,  House No, Locality, Landmark, City, PIN"
                    value={formData.address || ""}
                    onChange={handleInputChange}
                  />
                  {error.address && (
                    <span className={mainStyle.errorMsg}>{error.address}</span>
                  )}
                </div> */}
              </div>

              <div className={mainStyle.mainContentFormSplit}>
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Discription
                  </label>
                  <textarea
                    className={PageInputStyle.input}
                    name="description"
                    placeholder="e.g., Description..."
                    value={formData?.description || ""}
                    onChange={handleInputChange}
                  />
                  {error.description && (
                    <span className={mainStyle.errorMsg}>
                      {error.description}
                    </span>
                  )}
                </div>
                {/* <SelectBox
                                    options={companyList}
                                    label="Company"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleInputChange}  // Add this line
                                    placeholder="select a company"
                                    required
                                    multiple

                                    error={error.company}
                                /> */}
                <div
                  className={mainStyle.mainButtonDiv}
                  style={{ width: "100%" }}
                >
                  <Button onClick={handleFormSubmit}>
                    {" "}
                    {loading ? <Loader /> : "Invite"}
                  </Button>
                </div>
              </div>

              <br />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddChannelPage;
